import { useAddStatusNotification } from "features/notifications/hooks";

import { VSCODE_INSIDERS_INSTALL_URL } from "utils/vscode";

export function useMissingVsCodeInsidersNotification(): () => void {
  const dispatchNotification = useAddStatusNotification();

  return () => {
    dispatchNotification({
      status: "warning",
      message: "Visual Studio Insiders is not installed",
      actions: [
        {
          text: "Install",
          onAction() {
            window.open(
              VSCODE_INSIDERS_INSTALL_URL,
              "_blank",
              "noopener,noreferrer",
            );
          },
        },
      ],
    });
  };
}
